import type { CustomPaymentMethod } from '@stripe/stripe-js';

/**
 * Settings for HSA/FSA Truemed integration as a custom payment method at Stripe.
 * This enables HSA/FSA payment methods in the Stripe payment element.
 * For more details see:
 * https://docs.stripe.com/payments/payment-element/custom-payment-methods#add-cpm-to-elements
 * https://whoopinc.atlassian.net/wiki/spaces/PROD/pages/4631396744/Add+HSA+FSA+Integration+with+Truemed
 */

export const truemedCustomPaymentMethodSettings: CustomPaymentMethod = {
  id: process.env.NEXT_PUBLIC_TRUEMED_PAYMENT_METHOD_ID || '',
  options: {
    type: 'static',
  },
};
